<div class="modal-body text-center">
    <kh-img path="/add.png"></kh-img>
    <div class="modal-close-x" (click)="close()"><fa-icon [icon]="['fas', 'times']"></fa-icon></div>
    <div class="modal-subtitle">{{ 'DEMO_MESSAGE_MODAL.THIS_IS_A_DEMO_CLASS' | translate }}</div>
    <div class="modal-subtext">{{ 'DEMO_MESSAGE_MODAL.CREATE_A_NEW_CLASS_TO' | translate }}</div>
    <button (click)="addClass()" class="btn btn-lg btn-primary spacer-lg">{{ 'DEMO_MESSAGE_MODAL.CREATE_A_CLASS' | translate }}</button>
</div>
